import Layout from "../../../layouts";
import { Box } from "@mui/material";
import { GoalSettingTabMenu } from "../GoalSettingTabMenu";
import GoalManagementDataGrid from "./goal-management/GoalManagementDataGrid";
import { GoalSettingProvider } from "../../../contexts/GoalSettingContext";

const GoalSetting = () => {
  return (
    <GoalSettingProvider>
      <Layout>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flex={1}
          height={"100%"}
          color={"var(--dark)"}
        >
          <GoalSettingTabMenu />
          <Box
            p={"40px 40px"}
            display={"flex"}
            flexDirection="column"
            gap={"40px"}
            alignItems={"start"}
            flex={1}
            bgcolor={"var(--white)"}
          >
            <Box display={"flex"} flex={1} width={"100%"}>
              <GoalManagementDataGrid />
            </Box>
          </Box>
        </Box>
      </Layout>
    </GoalSettingProvider>
  );
};

export default GoalSetting;
